import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

import type { Placement } from 'tippy.js'
import type { ReactElement, ReactNode } from 'react'

interface Props {
    /** Nội dung tooltip. Rỗng/null = không gắn tooltip, trả thẳng children. */
    content: ReactNode
    /**
     * Phần tử neo tooltip. Tippy dùng `cloneElement` để gắn ref + handler nên
     * đây phải là MỘT element nhận được ref — thẻ DOM, hoặc component có
     * forward ref. Nút `disabled` không nhận hover (`pointer-events: none`),
     * nên bọc nó trong một thẻ `span` rồi truyền thẻ đó vào đây.
     */
    children: ReactElement
    placement?: Placement
}

/**
 * Tooltip dùng chung, chạy trên tippy.js.
 *
 * Cố tình KHÔNG dùng thuộc tính `title` của trình duyệt: `title` trễ ~1 giây
 * mới hiện, không style được, không xuống dòng được với message dài, và không
 * nằm trong DOM nên ảnh chụp màn hình lẫn test đều không thấy nó.
 *
 * `delay` và `duration` đều bằng 0: rê chuột vào là hiện ngay, không chờ.
 */
export function Tooltip({ content, children, placement = 'top' }: Props) {
    if (content === null || content === undefined || content === '') {
        return children
    }
    return (
        <Tippy
            content={content}
            placement={placement}
            theme="hd"
            delay={0}
            duration={0}
            maxWidth={360}
            // Render ở body để tooltip không bị cắt bởi ô bảng có overflow.
            appendTo={() => document.body}
        >
            {children}
        </Tippy>
    )
}
